import React from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Chip from "@mui/material/Chip";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";

// Короткий анонс на главной. Всё, что длиннее двух предложений, живёт в разделе
// ключей: инструкция нужна тому, кто уже решил подключаться, а не всем подряд.
const McpCard = () => {
  const navigate = useNavigate();

  return (
    <Card sx={{ m: 2 }}>
      <Box
        sx={{
          p: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", flex: 1 }}>
          <Typography sx={{ ml: 1, mr: 2 }} variant="h6" component="div">
            Переводы прямо в агенте
          </Typography>
          <Chip size="small" color="primary" label="Новое" />
        </Box>
        {/* Кнопка одна и потому contained: анонс ведёт ровно в одно место —
            в раздел ключей, где и инструкция, и выпуск. */}
        <Box sx={{ pl: 4, flexShrink: 0 }}>
          <Button variant="contained" onClick={() => navigate("/api-keys")}>
            Подробнее
          </Button>
        </Box>
      </Box>
      <Divider />
      <Box sx={{ p: 2 }}>
        <Typography variant="body2" color="text.secondary">
          Агент в редакторе кода читает и правит переводы напрямую — через MCP и
          личный API-ключ. Ключ работает с правами своего владельца, поэтому
          чужие проекты и языки остаются недоступны.
        </Typography>
      </Box>
    </Card>
  );
};

export default McpCard;
